import { PropertyBase } from './property-base.model';

export class BooleanValueProperty extends PropertyBase {
  constructor(data: any = {}) {
    super();
    this.title = data.title || 'Untitled';
    this.value = data.value || false;
  }
}
